// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/stylesheets/partials/journey-menu.scss
// module id = 446
// module chunks = 0